module.exports = __webpack_public_path__ + "img/project-sponser.bac91d5e.svg";